import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { tap, filter, take, catchError, map, switchMap } from 'rxjs/operators';
import { LoadingState } from '@app/shared/interfaces';
import { UsersFacade } from '@app/shared/+state/users';

@Injectable({
  providedIn: 'root',
})
export class UserLoadedGuard  {
  constructor(private usersFacade: UsersFacade) {}

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.usersFacade.userLoadingState$.pipe(
      map((loadingState) => loadingState === LoadingState.Pending || loadingState === LoadingState.Success),
      tap((loaded) => {
        if (!loaded) {
          this.usersFacade.loadUser();
        }
      }),
      filter((loaded) => loaded),
      take(1)
    );
  }
}
